import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TextComponent implements OnInit {
  public styles: any = {};
  @Input() text: string | null = '';
  @Input() colorClass: string = 'color-gray-400';
  @Input() fontSize: number = 14;
  @Input() fontFamily: 'SourceSans' | 'OpenSans' = 'SourceSans';
  @Input() type:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'paragraph'
    | 'span'
    | 'div'
    | 'label'
    | 'link'
    | 'rLink' = 'div';
  @Input() pathLink: string | undefined;
  @Input() target:
    | '_blank'
    | '_self'
    | '_parent'
    | '_top'
    | undefined;
  @Input() customStyles: {} | undefined;
  @Input() fontWeight:
    | '100'
    | '200'
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '900' = '400';
  @Input() lineHeight: number = 19;

  constructor() {}

  ngOnInit(): void {
    const font = {
      SourceSans: '"Source Sans Pro", sans-serif',
      OpenSans: '"Open Sans", sans-serif',
    }[this.fontFamily];

    this.styles = {
      fontFamily: font,
      fontSize: `${this.fontSize}px`,
      fontWeight: this.fontWeight,
      lineHeight: `${this.lineHeight}px`,
      ...this.customStyles,
    };
  }
}
